import React, { Component } from "react";
import { Script } from "gatsby";
import { getPlatformType, andr, ios } from "../../utils/device";
import { getSession, setSession } from "src/utils/localStorage";
import request from "src/utils/request";
import { CONNECT, CONNECT_CLIENT } from "src/utils/definitions";


export default class InApp extends Component {
  componentDidMount() {
    window.addEventListener("jwtTokenRenewed", (payload) => { this.processToken(payload.detail) });
    this.requestRefreshToken(getPlatformType())
  }

  componentWillUnmount(){
    window.removeEventListener("jwtTokenRenewed", this.processToken);
  }

  requestRefreshToken = (platform) => {
    if (platform === andr) {
      if(window && window.JSInterface && window.JSInterface.skRequestRefreshUserToken) {
        window.JSInterface.skRequestRefreshUserToken();
      }
    } else if (platform === ios) {
      if(window && window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.skRequestRefreshUserToken && window.webkit.messageHandlers.skRequestRefreshUserToken.postMessage) {
        window.webkit.messageHandlers.skRequestRefreshUserToken.postMessage('');
      }
    } else {
      alert('Error getting TOKEN renew request');
    }
  }

  processToken = (token = "") => {
    const session = getSession();
    request({
      method: "POST",
      url: `${CONNECT}/flamingo/process-token`,
      data: {
        client: CONNECT_CLIENT,
        data: {
          session: session?.uuid,
          token
        }
      }
    })
    .catch((err) => { console.error(err)})
    .then(response => {
      if (response && response.data && response.data.customer) {
        setSession({
          ...session,
          updated_at: response.data.updated_at,
          customer: response.data.customer
        })
      }
    })
  }

  render(){
    return (
      <Script
        dangerouslySetInnerHTML={{
          __html: `
            if (typeof window.skRecieveUserToken !== 'function') {
              window.skRecieveUserToken = (token) => {
                const event = new CustomEvent('jwtTokenRenewed', { detail: token });
                return window.dispatchEvent(event);
              };
            }
          `
        }}
      />
    )
  }
}